import { UUID } from '@/api/generatedApi';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useQuery } from '@tanstack/react-query';

export const GET_PART_FINDER_REPORT_THUMBNAIL_QUERY_KEY = 'partFinderReports.getThumbnail';

export const useGetPartFinderReportThumbnail = ({
  reportId,
  version,
  enabled = true,
}: {
  reportId: UUID;
  version?: string;
  enabled?: boolean;
}) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();
  const {
    data: thumbnail,
    isLoading,
    error,
  } = useQuery({
    queryKey: [GET_PART_FINDER_REPORT_THUMBNAIL_QUERY_KEY, { reportId, version }],
    queryFn: async () => {
      const { data, status, headers } = await api.http.request<Blob>({
        path: `/tenants/${tenantId}/part-finder/reports/${reportId}/thumbnail.png`,
        method: 'GET',
        secure: true,
        format: 'blob',
        query: version ? { v: version } : undefined,
      });

      if (status !== 200) {
        throw new Error('Failed to download part finder report thumbnail');
      }

      const contentType = headers['content-type'];
      return URL.createObjectURL(new Blob([data], { type: typeof contentType === 'string' ? contentType : undefined }));
    },
    enabled: enabled && !!reportId && !!tenantId,
    refetchOnMount: false,
    retry: false,
    staleTime: 60 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  });

  return { thumbnail, isLoading, error };
};
